import { render, staticRenderFns } from "./updateRole.vue?vue&type=template&id=3ba06df8&"
import script from "./updateRole.vue?vue&type=script&lang=js&"
export * from "./updateRole.vue?vue&type=script&lang=js&"
import style0 from "./updateRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports